import { useParams } from "react-router-dom";
import "./Results.css";
import MealPlans, { MealPlan } from "./MealPlans";
import { useEffect } from "react";

function Results() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { ageGroup, calories } = useParams<{
    ageGroup: string;
    calories: string;
  }>();

  const plan: MealPlan | undefined = MealPlans.find(
    (item) =>
      item.ageGroup === ageGroup && item.calories === parseInt(calories ?? "")
  );

  if (!plan) {
    return (
      <p className="text-center mt-10 text-red-600">
        ვერ მოიძებნა არსებული კომბინაციისთვის შესაბამისი გეგმა
      </p>
    );
  }

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-4xl font-bold text-center mb-2">
        შენი კალორიული გეგმა
      </h1>
      <p className="text-2xl text-center">{plan.calories} კალორია</p>
      <p className="text-lg text-center mb-6">ასაკი: {plan.ageText}</p>

      <p className="mb-6">
        ქვემოთ მოცემულია 6 ძირითადი საკვები ჯგუფი, თითოეულ საკვებ ჯგუფს
        შეესაბამება განსაზღვრული პორცია: მაგალითად: ხილი 1 პორცია ან მარცვლეული
        6 პორცია. ეს თითოეული ჯგუფის დღიური მისაღები რაოდენობაა. თუ ამ დოზებს
        დაიცავთ, ყველა მაკრო და მიკრონუტრიენტის ადექვატური რაოდენობით მიღების
        შანსი მნიშვნელოვნად გაიზრდება
      </p>

      <p className="text-start mb-6">
        <i>დღის განმავლობაში მიიღეთ დიდი რაოდენობით წყალი</i>
      </p>

      <div className="grid gap-6 md:grid-cols-2">
        {plan.foods.map((food) => (
          <div
            key={food.group}
            className="bg-white shadow-md rounded-2xl p-5 border border-gray-100"
          >
            <h2 className="text-xl font-bold mb-1">{food.group}</h2>
            <p className="font-semibold text-lg" style={{ color: "#123257" }}>
              {food.amount}
            </p>
            <p className="text-sm text-gray-600 mt-2">
              {food.description.split("\n").map((line, index) => (
                <span key={index} className="mb-1 block">
                  {index > 0 && "•"}
                  {line}
                  <br />
                </span>
              ))}
              <p className="text-xs text-gray-400">
                {food.recommendations.split("\n").map((line, index) => (
                  <span key={index} className="mb-1 block">
                    <i>{line}</i>
                    <br />
                  </span>
                ))}
              </p>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Results;
